module.exports = __webpack_public_path__ + "img/system4.116bb9d8.svg";